// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d17e4cfb","28":"bad95de5","144":"59adbc3d","195":"9dfde769","212":"6d81d46b","222":"f0ac5bc1","348":"fda4c7e1","465":"401abce0","539":"1f763e63","621":"33931d90","703":"678a18be","736":"c03bef0d","845":"f9c9a13b","929":"666c9482","933":"95b66886"}[chunkId] + ".chunk.js";
};